var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMonedero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "26px",
    viewBox: "0 0 33 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5.4 Monedero") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.9Reservaciones-Copy-2",
    transform: "translate(-85.000000, -963.000000)",
    stroke: "#FE8D27",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32",
    transform: "translate(68.000000, 715.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-10",
    transform: "translate(0.000000, 231.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.4-Monedero",
    transform: "translate(18.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,20.478 L0,2.748 C0,1.23 1.23,0 2.748,0 L28.183,0 C29.7,0 30.93,1.23 30.93,2.748 L30.93,20.478 C30.93,21.995 29.7,23.226 28.183,23.226 L2.748,23.226 C1.23,23.226 0,21.995 0,20.478 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8914,15.1858 L30.9304,15.1858 L30.9304,7.9628 L22.8914,7.9628 C20.8964,7.9628 19.2794,9.5798 19.2794,11.5738 L19.2794,11.5738 C19.2794,13.5688 20.8964,15.1858 22.8914,15.1858 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.8817,
    y1: 6.6373,
    x2: 5.8817,
    y2: 16.5113,
    id: "Stroke-5",
    strokeLinecap: "round"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonedero);
export default __webpack_public_path__ + "static/media/Monedero.86cb3c9573b4ba24ca48f2ca0d66eaba.svg";
export { ForwardRef as ReactComponent };